import React, { FunctionComponent, lazy, Suspense } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const StackedBarChartIconsMap = {
  Airwallex: lazy(() => import('./icons/Airwallex.icon.svg?react')),
  Checkout: lazy(() => import('./icons/Checkout.icon.svg?react')),
  Confirmo: lazy(() => import('./icons/Confirmo.icon.svg?react')),
  CreditCard: lazy(() => import('./icons/CreditCard.icon.svg?react')),
  Crypto: lazy(() => import('./icons/Crypto.icon.svg?react')),
  HubCredits: lazy(() => import('./icons/HubCredits.icon.svg?react')),
  TTPCredits: lazy(() => import('./icons/TTPCredits.icon.svg?react')),
  Paypal: lazy(() => import('./icons/Paypal.icon.svg?react')),
  Rise: lazy(() => import('./icons/Rise.icon.svg?react')),
  Visa: lazy(() => import('./icons/Visa.icon.svg?react')),
  Wise: lazy(() => import('./icons/Wise.icon.svg?react')),
  Fibonatix: lazy(() => import('./icons/Fibonatix.icon.svg?react')),
  Paysafe: lazy(() => import('./icons/Paysafe.icon.svg?react')),
} as const;

export type StackedBarChartIconNames = keyof typeof StackedBarChartIconsMap;

interface StackedBarChartIconProps extends SvgIconProps {
  iconName: StackedBarChartIconNames;
}

export const StackedBarChartIcon: FunctionComponent<
  StackedBarChartIconProps
> = ({ iconName, ...props }) => {
  const IconComponent = StackedBarChartIconsMap[iconName];

  return (
    <Suspense fallback={null}>
      <SvgIcon {...props} component={IconComponent} inheritViewBox />
    </Suspense>
  );
};
